// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.datatable-validated-hits {
  width: 100%;
}
.datatable-validated-hits .p-paginator .p-paginator-current {
  margin-left: auto;
}

.datatable-validated-hits .p-progressbar {
  height: 0.5rem;
  background-color: #d8dadc;
}

.datatable-validated-hits .p-progressbar .p-progressbar-value {
  background-color: #607d8b;
}

.datatable-validated-hits .table-header {
  display: flex;
  justify-content: space-between;
}

.datatable-validated-hits .table-header .heading {
  background: linear-gradient(to right, #30cfd0 0%, #332288 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.datatable-validated-hits .p-datepicker {
  min-width: 25rem;
}

.datatable-validated-hits .p-datepicker td {
  font-weight: 400;
}

.datatable-validated-hits .p-datatable.p-datatable-header {
  padding: 1rem;
  text-align: left;
  font-size: 2rem;
}

.datatable-validated-hits .p-datatable.p-paginator {
  padding: 1rem;
}

.datatable-validated-hits .p-datatable.p-datatable-thead > tr > th {
  text-align: left;
}

.datatable-validated-hits .p-datatable.p-datatable-tbody > tr > td {
  cursor: auto;
}

.datatable-validated-hits .p-datatable.p-dropdown-label:not(.p-placeholder) {
  text-transform: uppercase;
}

.datatable-validated-hits .p-datatable-tbody > tr > td .p-column-title {
  display: none;
}

.datatable-validated-hits .narrow-column {
  width: 200px !important;
}
.datatable-validated-hits .p-inputtext {
  font-size: 0.8rem;
}

@media screen and (max-width: 960px) {
  .datatable-validated-hits .p-datatable.p-datatable-thead > tr > th,
  .datatable-validated-hits .p-datatable.p-datatable-tfoot > tr > td {
    display: none !important;
  }

  .datatable-validated-hits .p-datatable.p-datatable-tbody > tr {
    border-bottom: 1px solid var(--layer-2);
  }

  .datatable-validated-hits .p-datatable.p-datatable-tbody > tr > td {
    text-align: left;
    display: block;
    border: 0 none !important;
    width: 100% !important;
    float: left;
    clear: left;
    border: 0 none;
  }

  .datatable-validated-hits .p-datatable.p-datatable-tbody > tr > td .p-column-title {
    padding: 0.4rem;
    min-width: 30%;
    display: inline-block;
    margin: -0.4rem 1rem -0.4rem -0.4rem;
    font-weight: bold;
  }

  .datatable-validated-hits .p-datatable.p-datatable-tbody > tr > td .p-progressbar {
    margin-top: 0.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/scene-d/Screen/ScreenView/ScreenTargetBased/ValidatedHits/ValidatedHitsList/ValidatedHitsDataTable.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,+DAA+D;EAC/D,6BAA6B;EAC7B,oCAAoC;AACtC;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE;;IAEE,wBAAwB;EAC1B;;EAEA;IACE,uCAAuC;EACzC;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,sBAAsB;IACtB,WAAW;IACX,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,qBAAqB;IACrB,oCAAoC;IACpC,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".datatable-validated-hits {\n  width: 100%;\n}\n.datatable-validated-hits .p-paginator .p-paginator-current {\n  margin-left: auto;\n}\n\n.datatable-validated-hits .p-progressbar {\n  height: 0.5rem;\n  background-color: #d8dadc;\n}\n\n.datatable-validated-hits .p-progressbar .p-progressbar-value {\n  background-color: #607d8b;\n}\n\n.datatable-validated-hits .table-header {\n  display: flex;\n  justify-content: space-between;\n}\n\n.datatable-validated-hits .table-header .heading {\n  background: linear-gradient(to right, #30cfd0 0%, #332288 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n.datatable-validated-hits .p-datepicker {\n  min-width: 25rem;\n}\n\n.datatable-validated-hits .p-datepicker td {\n  font-weight: 400;\n}\n\n.datatable-validated-hits .p-datatable.p-datatable-header {\n  padding: 1rem;\n  text-align: left;\n  font-size: 2rem;\n}\n\n.datatable-validated-hits .p-datatable.p-paginator {\n  padding: 1rem;\n}\n\n.datatable-validated-hits .p-datatable.p-datatable-thead > tr > th {\n  text-align: left;\n}\n\n.datatable-validated-hits .p-datatable.p-datatable-tbody > tr > td {\n  cursor: auto;\n}\n\n.datatable-validated-hits .p-datatable.p-dropdown-label:not(.p-placeholder) {\n  text-transform: uppercase;\n}\n\n.datatable-validated-hits .p-datatable-tbody > tr > td .p-column-title {\n  display: none;\n}\n\n.datatable-validated-hits .narrow-column {\n  width: 200px !important;\n}\n.datatable-validated-hits .p-inputtext {\n  font-size: 0.8rem;\n}\n\n@media screen and (max-width: 960px) {\n  .datatable-validated-hits .p-datatable.p-datatable-thead > tr > th,\n  .datatable-validated-hits .p-datatable.p-datatable-tfoot > tr > td {\n    display: none !important;\n  }\n\n  .datatable-validated-hits .p-datatable.p-datatable-tbody > tr {\n    border-bottom: 1px solid var(--layer-2);\n  }\n\n  .datatable-validated-hits .p-datatable.p-datatable-tbody > tr > td {\n    text-align: left;\n    display: block;\n    border: 0 none !important;\n    width: 100% !important;\n    float: left;\n    clear: left;\n    border: 0 none;\n  }\n\n  .datatable-validated-hits .p-datatable.p-datatable-tbody > tr > td .p-column-title {\n    padding: 0.4rem;\n    min-width: 30%;\n    display: inline-block;\n    margin: -0.4rem 1rem -0.4rem -0.4rem;\n    font-weight: bold;\n  }\n\n  .datatable-validated-hits .p-datatable.p-datatable-tbody > tr > td .p-progressbar {\n    margin-top: 0.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
